import http from '@/http'

const CATEGORIES_RECEIVED = 'CATEGORIES_RECEIVED'

const state = {
  items: [],
  isLoaded: false
}

const getters = {
  idToName(state) {
    return state.items.reduce((map, category) => {
      map.set(category.id, category.name)
      return map
    }, new Map())
  }
}

const actions = {
  async getCategories ({ commit }) {
    try {
      if (!state.isLoaded) {
        const { data } = await http.get('/medias/categories-list')
        commit(CATEGORIES_RECEIVED, { categories: data })
      }
    } catch (err) {
      console.log('err :>> ', err)
    }
  }
}

const mutations = {
  [CATEGORIES_RECEIVED] (state, { categories }) {
    state.items = categories
    state.isLoaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
